export default "__VITE_ASSET__oA$J1O7w__"